import { CircleAlert } from "lucide-react";
import { cn } from "../../lib/utils";
import { InputMask } from "primereact/inputmask";
import { useTranslation } from "react-i18next";


export default function OAMaskInput({
    placeholder = "",
    name,
    type = "text",
    error=null,
    className,
    value="",
    slotChar = undefined,
    mask = undefined,
    ...props
  }) {
    const {t} = useTranslation()
    return (
      <fieldset className="relative animate-fade-in-down flex-1 flex flex-col gap-1">
        <InputMask
          className={cn(`w-full h-10 px-2 py-3 border bg-white border-oaInputBorderColor rounded-[8px] ${error ? 'border-2 border-oaRed':''}`, className)}
          defaultValue={value}
          name={name}
          type={type}
          placeholder={placeholder}
          slotChar={slotChar}
          mask={mask}
          {...props}
        />
       <div className="flex gap-1 justify-start items-start text-oaRed">
          {error && <>
            <CircleAlert className="size-4 "/>
            <p className="text-xs flex-1">{t(error)}</p>
          </>}
        </div>  
      </fieldset>
    );
  }